import * as _ from 'lodash'
import { BRANDCHOSEN } from './config'
export const categoriesUnique = (products, categories) => {
    const categoriesAll = [];
    const categoriesAllOrder = [];
    const categoryOther = [];
  
    for (let i = 0; i < products.length; i++) {
      const categoria = products[i].Categoria;
  
      if (categoria && categoria !== '') {
        if (categoria.toLowerCase().trim() === 'otros') {
          categoryOther.push({ nombre: categoria.toLowerCase().trim() });
        } else {
          const currentCategories = categories[BRANDCHOSEN] ? categories[BRANDCHOSEN] : categories;
  
          const filtered = _.filter(currentCategories, (c) => {
            return c.Name.toLowerCase().trim() === categoria.toLowerCase().trim();
          });
  
          if (filtered.length > 0) {
            categoriesAll.push(filtered[0]);
          }
        }
      }
    }
  
    const distinct = _.uniqBy(categoriesAll, 'Name');
    const distinctOther = _.uniqBy(categoryOther, 'Name');
    const categoriesOrder = _.sortBy(distinct, ['Position'], ['asc']);
  
    for (let i = 0; i < categoriesOrder.length; i++) {
      const categorie = categoriesOrder[i];
      categoriesAllOrder.push({ nombre: categorie.Name });
    }
  
    return categoriesAllOrder.concat(distinctOther);
  };

export const categoriesAllParse = (categories) => {
    const selectedCategories = categories[BRANDCHOSEN] ? categories[BRANDCHOSEN] : categories;
    const orderedCategories = _.sortBy(selectedCategories, ['Position'], ['asc']);
  
    const parsed = [];
    for (let i = 0; i < orderedCategories.length; i++) {
      if (orderedCategories[i].Categoria !== '') {
        parsed.push({ nombre: orderedCategories[i].Name.trim() });
      }
    }
  
    return _.uniqBy(parsed, 'nombre');
  };